

import React, { useState } from "react";
import { RiDeleteBin6Line } from "react-icons/ri";
import { BiSolidEdit } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { createCommentForAccident, deleteComment, updateComment } from "../redux/apiCalls/accidentApiCall";

function AdminNotizen() {
  const { lastAccident } = useSelector(state => state.accident);
  const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editableNoteId, setEditableNoteId] = useState(null);
  const dispatch = useDispatch();

  const handleAddOrUpdateComment = () => {
    if (!text.trim() || !title.trim()) {
      alert("Bitte geben Sie sowohl einen Titel als auch einen Kommentar ein.");
      return;
    }

    if (editableNoteId) {
      dispatch(updateComment(editableNoteId, text, title));
    } else {
      dispatch(createCommentForAccident(title, text, lastAccident._id));  
    }

    resetModal();
  };

  const resetModal = () => {
    setText("");
    setTitle("");
    setEditableNoteId(null);
    setIsModalOpen(false);
  };

  const handleEditClick = (row) => {
    setTitle(row.title)
    setText(row.text);
    setEditableNoteId(row._id);
    setIsModalOpen(true);
  };

  const renderDate = (e) => {
    const dateString = e;
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}.${month}.${year}`;
  };
const handelClose = () => {
  setIsModalOpen(false);
  setText("");
  setTitle("");
}
  return (
    <div className="overflow-x-auto">
      {lastAccident.notes.length > 0 ? (
        <table className="min-w-full border border-gray-300 rounded-lg shadow-lg">
          <thead className="bg-gradient-to-r from-black to-[#DAA520] text-white">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-[700] border-b border-gray-400">Betreff</th>
              <th className="px-6 py-3 text-left text-sm font-[700] border-b border-gray-400">ADatum</th>
              <th className="px-6 py-3 text-center text-sm font-[700] border-b border-gray-400">Aktion</th>
            </tr>
          </thead>

          <tbody>
            {lastAccident.notes.map((row, index) => (
              <tr
                key={row.id}
                className={`${index % 2 === 0 ? "bg-white" : "bg-gray-100"} hover:bg-gray-200 transition-all`}
              >
                <td className="px-6 py-[5px] text-sm font-[700] border-b border-gray-300">{row.title}</td>
                <td className="px-6 py-[5px] text-sm font-[700] border-b border-gray-300">{renderDate(row.createdAt)}</td>
                <td className="px-6 py-[5px] text-center border-b border-gray-300">
                  <button onClick={() => dispatch(deleteComment(row._id))} className="text-[#fe4040] transition-all hover:text-[#d85f5f] mx-2">
                    <RiDeleteBin6Line className="text-[22px]" />
                  </button>
                  <button onClick={() => handleEditClick(row)} className="text-[#54d8fb] transition-all hover:text-blue-700">
                    <BiSolidEdit className="text-[22px]" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="text-center mt-[10px] font-bold text-[20px]">There are no notes</div>
      )}
      <div className="flex justify-center items-center mt-6 absolute bottom-[40px] left-[50%]">
        <button onClick={() => setIsModalOpen(true)} className="bg-[#DAA520] hover:bg-[#b8911a] text-black font-semibold py-2 px-4 border-[1px] border-[black] rounded shadow-md">
          + Neue Notiz
        </button>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 bg-[#333] bg-opacity-[0.5] flex items-center justify-center z-50">
          <div
            className="bg-[rgb(237,237,235)] p-6 rounded-lg shadow-lg w-[600px] animate-fade-in-down"
            style={{ animationDuration: "0.3s" }}
          >
            <h2 className="text-lg font-bold mb-4 text-center">Schreiben Sie bitte hier Ihre Notizen</h2>
            <div className="flex flex-col mb-4">
              <p >title:</p>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="flex-1 bg-[rgb(200,232,239)] px-4 py-2 h-[100px] rounded-[5px] focus:outline-none"
              />
            </div>
            <div className="flex flex-col w-[100%] h-[100%] mb-4">
            <p>text:</p>
              <textarea
                type="text"
                value={text}
                onChange={(e) => setText(e.target.value)}
                className="flex-1 bg-[rgb(200,232,239)] px-4 py-2 h-[100px] rounded-[5px] focus:outline-none resize-none"
              />
            </div>
            <div className="flex justify-center mt-4">
              <button
                onClick={handleAddOrUpdateComment}
                className="bg-[#DAA520] hover:bg-[#b8911a] text-black font-semibold py-2 px-4 border-[1px] border-[black] rounded shadow-md">
                {editableNoteId ? "Aktualisieren" : "Hinzufügen"}
              </button>
              <button onClick={handelClose} className="bg-[#DAA520] hover:bg-[#b8911a] text-black font-semibold py-2 px-4 border-[1px] border-[black] rounded shadow-md ml-[10px]">schließen</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminNotizen;